import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { IReferredUserResponse } from "@finbackoffice/clientbff-client";
import {
    ComparisonFilterExpression,
    FilterCondition,
    FilterKind,
    IFilter,
    Order,
    StringFilterExpression,
} from "@finbackoffice/http-client";
import { BonusVertical } from "@finbackoffice/enums";
import { ClientBFFContext } from "../../providers";
import { DEFAULT_PAGINATION } from "../../types";
import { AgentConfigContext } from "./agent-config.provider";

export interface IEditColSubuser {
    userId?: number;
    type?: BonusVertical.Casino | BonusVertical.Sport | BonusVertical.LiveCasino;
    value: number;
}

export const useAgentPlayersList = (searchQuery?: string) => {
    const client = useContext(ClientBFFContext);
    const { agentConfig, updateAgentConfig } = useContext(AgentConfigContext);
    const [pagination, setPagination] = useState(DEFAULT_PAGINATION);
    const [players, setPlayers] = useState<IReferredUserResponse[]>([]);
    const [editCol, setEditCol] = useState<IEditColSubuser | null>(null);
    const [totalPages, setTotalPages] = useState<number>(0);
    const playersInfo = useMemo(() => {
        const usersRateSport = (agentConfig?.Sport?.users || []).reduce(
            (acc, user) => {
                acc[user.user_id] = user.rate || 0;
                return acc;
            },
            {} as Record<string, number>,
        );
        // const usersRateLiveCasino = (agentConfig?.LiveCasino?.users || []).reduce(
        //     (acc, user) => {
        //         acc[user.user_id] = user.rate || 0;
        //         return acc;
        //     },
        //     {} as Record<string, number>,
        // );
        // const usersRateCasino = (agentConfig?.Casino?.users || []).reduce(
        //     (acc, user) => {
        //         acc[user.user_id] = user.rate || 0;
        //         return acc;
        //     },
        //     {} as Record<string, number>,
        // );
        return (players || []).map((player) => ({
            ...player,
            sportRate: usersRateSport[player.id] || 0,
            // liveCasinoRate: usersRateLiveCasino[player.id] || 0,
            // casinoRate: usersRateCasino[player.id] || 0,
        }));
    }, [agentConfig, players]);

    const updateSubuserRate = useCallback(async () => {
        const newData = { ...agentConfig! };
        // let isFind = false;
        // agentConfig![editCol!.type!]!.users?.forEach((user) => {
        //     if (user.user_id === editCol?.userId) {
        //         user.rate = editCol!.value;
        //         isFind = true;
        //     }
        // });
        // if (!isFind) {
        //     newData[editCol!.type!]!.users!.push({
        //         user_id: editCol!.userId!,
        //         rate: editCol!.value,
        //     });
        // }
        await updateAgentConfig(newData);
        setEditCol(null);
    }, [agentConfig, updateAgentConfig]);

    const getAgentRate = useCallback(
        ({ type, userId, userRate }: { type: BonusVertical; userId: number; userRate: number }) => {
            console.log("type", type);
            // @TODO: check live casino and slots cashback backend api
            const value =
                editCol?.type === type && userId === editCol.userId ? editCol.value : userRate;
            return parseFloat(
                ((agentConfig?.[BonusVertical.Sport]?.default_rate || 0) - (value || 0)).toFixed(2),
            );
        },
        [agentConfig, editCol?.type, editCol?.userId, editCol?.value],
    );

    const loadPlayers = useCallback(async () => {
        let filter: IFilter<IReferredUserResponse>[] = [];
        if (searchQuery) {
            filter = [
                {
                    kind: FilterKind.StringFilter,
                    field: "username",
                    value: searchQuery,
                    expression: StringFilterExpression.Match,
                },
                {
                    kind: FilterKind.StringFilter,
                    field: "last_name",
                    value: searchQuery,
                    expression: StringFilterExpression.Match,
                },
                {
                    kind: FilterKind.StringFilter,
                    field: "first_name",
                    value: searchQuery,
                    expression: StringFilterExpression.Match,
                },
            ];

            if (!Number.isNaN(Number(searchQuery))) {
                filter.push({
                    kind: FilterKind.NumericFilter,
                    field: "id",
                    value: Number(searchQuery),
                    expression: ComparisonFilterExpression.Match,
                });
            }
        }
        try {
            const response = await client.queryReferredUser({
                page: pagination.page,
                items_per_page: pagination.items_per_page,
                order_by: [
                    {
                        field: "created_at",
                        order: Order.DESC,
                    },
                ],
                filter,
                filter_condition: FilterCondition.Or,
            });
            setPlayers(response.items);
            setTotalPages(response.total_pages);
        } catch {
            setPlayers([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagination]);

    useEffect(() => {
        setPagination({ ...pagination, page: 1 });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery]);

    useEffect(() => {
        loadPlayers();
    }, [loadPlayers]);

    return useMemo(
        () => ({
            updateSubuserRate,
            totalPages,
            playersInfo,
            getAgentRate,
            pagination,
            setPagination,
            editCol,
            setEditCol,
        }),
        [
            updateSubuserRate,
            totalPages,
            playersInfo,
            getAgentRate,
            pagination,
            setPagination,
            editCol,
            setEditCol,
        ],
    );
};
